export default "__VITE_ASSET__10061d99__"